import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const endOfTrialExtensionEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "end-of-trial-extension" */ './index'),
	),
	getPreloadProps: () => ({}),
});
